import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./SelfServiceTools/redux/store";
import { Provider } from "react-redux";

// ReactDOM.render(
//   <Provider store={store}>
//     <React.StrictMode>
//         <App />
//     </React.StrictMode>
//   </Provider>,
//   document.getElementById("family-root")
// );

const mount = (el) => {
  ReactDOM.render(
    <Provider store={store}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </Provider>,
    el
  );
};

window.mountSelfServiceTools = mount;

if (!window.containerContext) {
  mount(document.getElementById("family-root"));
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
